import React, { useEffect } from 'react';

import AOS from 'aos';
import 'aos/dist/aos.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Tractor, Clipboard, Globe, ShoppingCart } from 'lucide-react';


// Import team images
import team1 from '../assets/img/team/Patience.png';
import team2 from '../assets/img/team/Andrew.jpg';
import team3 from '../assets/img/team/Elsy.png';
import team4 from '../assets/img/team/Elvis.png';
import pageTitleBg from '../assets/img/page-title-bg.webp';



const About = () => {
  useEffect(() => {
    // Initialize AOS animation library
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });

    // Initialize GLightbox for video modal
    const lightbox = GLightbox({
      selector: '.glightbox'
    });

    return () => {
      // Clean up
      if (lightbox) lightbox.destroy();
    }
  }, []);

  return (
    <div className="about-page">
     
        <link rel="canonical" href="https://www.zaoafrika.co.ke/" />
        <title>Zao Afrika | Empowering Farmers, Growing Futures</title>
        <meta
          name="description"
          content="Zao Afrika empowers farmers through organic farming, value addition, and access to premium markets. Discover our contract farming, agri-tech solutions, and high-value crop portfolio including chia, flax, quinoa, moringa, avocado, and macadamia. Join us in growing sustainable futures."
        />
      
      <Header />
      
      <main className="main">
        {/* Page Title */}
          <div 
            className="page-title dark-background" 
            data-aos="fade" 
            style={{ backgroundImage: `url(${pageTitleBg})` }}
          >
            <div className="container position-relative">
              <h1>About</h1>
              <p>At Zao Afrika, we focus on maximizing profitability and delivering strong returns for farmers and investors alike. We have a wide network of farmers, agronomists, buyers and other stakeholders working together to ensure farmers have access to the best resources. We are committed to empowering farmers to grow their businesses and improve their livelihoods through our services designed to reduce farming risks, improve productivity, and ensure fair pricing.</p>
              
            </div>
          </div>

          {/* About 3 Section */}
          <section id="about-3" className="about-3 section">
          <div className="container">
            <div className="row gy-4 justify-content-between align-items-center">
              <div className="col-lg-6 order-lg-2 position-relative" data-aos="zoom-out">
                <img 
                  src="/assets/img/Website media/Zao1.png" 
                  alt="Plants make life better" 
                  className="img-fluid" 
                />
                <a href="https://youtu.be/kLphIEaYxic?si=Jru8Bqba5EaqVdWk" className="glightbox pulsating-play-btn">
                  <span className="play"><i className="bi bi-play-fill" /></span>
                </a>
              </div>
              <div className="col-lg-5 order-lg-1" data-aos="fade-up" data-aos-delay={100}>
                <h2 className="content-title mb-4">Our Crop Portfolio</h2>
                <p className="mb-4">
                At Zao Afrika, we focus on six high-value superfoods: chia seeds, flax seeds, quinoa, moringa, avocado, and macadamia nuts. Each crop offers high nutritional and market potential.
                </p>
                <ul className="list-unstyled list-check" style={{ textAlign: 'left' }}>
                  <li>Chia seeds are rich in omega-3 fatty acids, fiber, and antioxidants, supporting heart health and digestion.</li>
                  <li>Flax seeds provide essential omega-3s and lignans, promoting heart and hormonal health.</li>
                  <li>Quinoa is a great source of gluten-free protein.</li>
                  <li>Moringa has high vitamin and mineral content.</li>
                  <li>Avocado contains unsaturated fats and antioxidants.</li>
                  <li>Macadamia nuts contain healthy fats, magnesium, and brain-boosting antioxidants.</li>
                </ul>
                <p><a href="/contact" className="btn-cta">More information</a></p>
              </div>
            </div>
          </div>
        </section>

        {/* Team Section */}
          <section className="team-15 team section" id="team">
            <div className="container section-title" data-aos="fade-up">
              <h2>Our Team</h2>
              <p>Meet the team behind Zao Afrika</p>
            </div>

            <div className="content">
              <div className="container">
                <div className="row">
            {/* Team Member 1 */}
                <div className="col-lg-3 col-md-6 mb-4">
                  <div className="person">
                    <figure>
                      <img src={team1} alt="Patience Keter" className="img-fluid" />
                      
                    </figure>
                    <div className="person-contents">
                      <h3>Patience Keter</h3>
                      <span className="position">Chief Executive Officer (CEO)</span>
                    </div>
                  </div>
                </div>

                {/* Team Member 2 */}
                <div className="col-lg-3 col-md-6 mb-4">
                  <div className="person">
                    <figure>
                      <img src={team2} alt="Andrew Adema" className="img-fluid" />
                      
                    </figure>
                    <div className="person-contents">
                      <h3>Andrew Adema</h3>
                      <span className="position">Chief Technical Officer (CTO)</span>
                    </div>
                  </div>
                </div>

                {/* Team Member 3 */}
                <div className="col-lg-3 col-md-6 mb-4">
                  <div className="person">
                    <figure>
                      <img src={team3} alt="Elsy Jelimo" className="img-fluid" />
                      
                    </figure>
                    <div className="person-contents">
                      <h3>Elsy Jelimo</h3>
                      <span className="position">Chief Finance Officer (CFO)</span>
                    </div>
                  </div>
                </div>

                {/* Team Member 4 */}
                <div className="col-lg-3 col-md-6 mb-4">
                  <div className="person">
                    <figure>
                      <img src={team4} alt="Elvis Njau" className="img-fluid" />
                      
                    </figure>
                    <div className="person-contents">
                      <h3>Elvis Njau</h3>
                      <span className="position">Chief Relations Officer (CRO)</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* About Section */}
          <section className="about">
            <div className="content">
              <div className="container">
                <div className="row">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img 
                src="/assets/img/23.jpg" 
                alt="Zao Afrika Chia Seeds" 
                className="img-fluid img-overlap" 
                data-aos="zoom-out" 
              />
            </div>
            <div className="col-lg-5 ml-auto" data-aos="fade-up" data-aos-delay={100}>
              <h3 className="content-subtitle text-white opacity-50">What We Do</h3>
              <h2 className="content-title mb-4">
                <strong>Organic Farming & Value Chain Addition</strong> 
              </h2>
              <p className="opacity-50" style={{ textAlign: 'left' }}>
              Our mission is to drive sustainable production of organic food and value addition, while enhancing access to premium markets through innovation, technology, and financial inclusion. Our main services include:
              </p>
              <div className="row my-5">
                <div className="col-lg-12 d-flex align-items-start mb-4">
                  <Tractor className="me-7 display-6" size={48} />
                  <div>
              <h4 className="m-0 h5 text-white">Contract Farming Agreements</h4>
              <p className="text-white opacity-50" style={{ textAlign: 'left' }}>Secure structured contracts, access quality inputs, and harvest with confidence knowing your buyer, price, and expected earnings in advance!</p>
                  </div>
                </div>
                <div className="col-lg-12 d-flex align-items-start mb-4">
                  <Clipboard className="me-4 display-6" size={44} />
                  <div>
              <h4 className="m-0 h5 text-white">Harvest Purchase Agreements</h4>
              <p className="text-white opacity-50" style={{ textAlign: 'left' }}>Not in a contract but still looking for a reliable buyer? We buy directly from farmers at competitive market prices.</p>
                  </div>
                </div>
                
                <div className="col-lg-12 d-flex align-items-start">
                  <ShoppingCart className="me-4 display-6" size={56} />
                  <div>
              <h4 className="m-0 h5 text-white">Logistics & Aggregation</h4>
              <p className="text-white opacity-50"style={{ textAlign: 'left' }}>We provide threshing, cleaning, dehusking, sorting, packaging, transportation and logistics of bulk farm produce.</p>
                  </div>
                </div>
                <div className="col-lg-12 d-flex align-items-start mb-4">
                  <Globe className="me-4 display-6" size={40} />
                  <div>
              <h4 className="m-0 h5 text-white">Agri-Tech Solutions</h4>
              <p className="text-white opacity-50" style={{ textAlign: 'left' }}>We provide real-time farmer support through emerging technologies including AI.</p>
                  </div>
                </div>
              </div>
            </div>
                </div>
              </div>
            </div>
          </section>

          {/* Call To Action Section */}
        <section id="call-to-action" className="call-to-action section light-background">
          <div className="content">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <h3>Subscribe To Our Newsletter</h3>
                  <p className="opacity-50">
                  Stay updated with our latest news about organic farming, market insights,
                  and agricultural best practices!
                  </p>
                </div>
                <div className="col-lg-6">
                  <form action="forms/newsletter.php" className="form-subscribe php-email-form">
                    <div className="form-group d-flex align-items-stretch">
                      <input type="email" name="email" className="form-control h-100" placeholder="Enter your e-mail" />
                      <input type="submit" className="btn btn-secondary px-4" value="Subcribe" />
                    </div>
                    <div className="loading">Loading</div>
                    <div className="error-message"></div>
                    <div className="sent-message">
                      Your subscription request has been sent. Thank you!
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

     
      {/* Scroll Top */}
      <a href="/about" id="scroll-top" className="scroll-top d-flex align-items-center justify-content-center">
        <i className="bi bi-arrow-up-short"></i>
      </a>
        
        {/* Footer */}
        <Footer />
    </div>
  );
};

export default About;